import { formatCollabFeeFloor } from '@/components/subscription/plan-fees/format-collab-fee-floor';
import { useAuth } from '@/contexts/auth-context';
import { formatSuccessFeeRate } from '@/libs/utils/format-success-fee-rate';
import { Flex, Text } from '@chakra-ui/react';
import { PLAN_FEE_GRID, type BrandSalesChannel } from '@fluenceur/types';
import { PercentageCircle } from 'iconoir-react';
import { Trans, useTranslation } from 'react-i18next';

/**
 * Quote the shared free-plan fees for the declared sales platform.
 * Affiliate-sales fees only appear for the supported Shopify connection.
 */
export const FreePlanStrip = ({ salesChannel }: { salesChannel: BrandSalesChannel | null }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const locale = t('common.locale');
  const { successFeeBasisPoints, collabFee } = PLAN_FEE_GRID.free;
  const values = {
    ...(salesChannel === 'shopify'
      ? { rate: formatSuccessFeeRate(successFeeBasisPoints, locale) }
      : {}),
    collabRate: formatSuccessFeeRate(collabFee.basisPoints, locale),
    floor: formatCollabFeeFloor(
      collabFee.floorMinorUnits,
      user?.currentBrand?.currency?.toUpperCase(),
      locale
    ),
  };

  return (
    <Flex align="center" gap="10px" bg="white" borderRadius="16px" px="16px" py="12px">
      <PercentageCircle
        width={18}
        height={18}
        color="var(--chakra-colors-green-600)"
        style={{ flex: 'none' }}
        aria-hidden
      />
      <Text fontSize="12.5px" lineHeight="1.45" color="navInactive">
        <Trans
          i18nKey={
            salesChannel === 'shopify'
              ? 'onboarding.freePlanStrip'
              : 'onboarding.freePlanStripWithoutAffiliateSales'
          }
          values={values}
          components={{ strong: <strong /> }}
        />
      </Text>
    </Flex>
  );
};
